import React from 'react';
import Hero from './Hero';
import PathwayCards from './PathwayCards';

const HomeScreen = ({ onConfigureKit, onBrowseProducts, onGetGuidance, onNavigate }) => {
  return (
    <div className="min-h-screen bg-white/40">
      <div className="container mx-auto px-6 py-12">
        <Hero />
        <PathwayCards 
          onConfigureKit={onConfigureKit}
          onBrowseProducts={onBrowseProducts}
          onGetGuidance={onGetGuidance}
          onNavigate={onNavigate}
        />
      </div>
    </div>
  );
};

export default HomeScreen;